import { defineStore } from 'pinia';

export const useUiStore = defineStore('ui', {
    state: () => ({
        currentPage: 1,
        sidebarOpen: true,
        paginationStartRange: 1,
        paginationEndRange: 25,
        perPage: 25,
        searchResultsLimit: 200,
        sort: null,
        totalResults: null,
    }),
    getters: {
        lastPage() {
            return Math.ceil(this.totalResults / this.perPage);
        },
        startRange() {
            return this.currentPage <= 1
                ? 1
                : this.perPage * (this.currentPage - 1) + 1;
        },
        endRange() {
            if (this.currentPage === this.lastPage) {
                return this.totalResults;
            }
            return this.perPage * this.currentPage;
        },
    },

    actions: {
        nextPage() {
            this.currentPage++;
        },
        prevPage() {
            this.currentPage--;
        },
        setCurrentPage(page) {
            this.currentPage = page;
        },
        setTotalResults(count) {
            const num =
                count > this.searchResultsLimit
                    ? this.searchResultsLimit
                    : count;
            this.totalResults = num;
        },
        setSidebarOpen(isOpen) {
            this.sidebarOpen = isOpen;
        },
        setSort(value) {
            this.sort = value;
            this.setCurrentPage(1);
        },
        setPaginationStartRange(range) {
            this.paginationStartRange = range;
        },
        setPaginationEndRange(range) {
            this.paginationEndRange = range;
        },
        setPerPage(perPage) {
            this.perPage = perPage;
        },
    },
});
